import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'
import { useDeleteCampaign } from './useDeleteCampaign'

export type DeleteCampaignModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  givingCampaign: {
    id: string
    title: string
  } | null
  onSuccess: () => void
  onError: (error?: Record<'code' | 'message' | 'title', string>) => void
}>

export function DeleteCampaignModal({
  isOpen,
  handleClose,
  givingCampaign,
  onSuccess,
  onError
}: DeleteCampaignModalProps) {
  const { t } = useTranslation()

  const { isLoading, deleteCampaign } = useDeleteCampaign({
    campaignId: givingCampaign?.id,
    onDeleted: onSuccess,
    onError
  })

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ActionModal
        title={t('typography.givingCampaigns.deleteCampaign.title')}
        primaryButtonText={t('typography.givingCampaigns.deleteCampaign.button')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={deleteCampaign}
        loading={isLoading}
      >
        <Trans
          i18nKey="typography.givingCampaigns.deleteCampaign.description"
          components={{ b: <b /> }}
          values={{ campaignName: givingCampaign?.title ?? '' }}
        />
      </ActionModal>
    </Modal>
  )
}
